export enum MessageCategories {
    INBOX = 'inbox',
    UNREAD = 'unread',
    SENT = 'outbox',
    DRAFT = 'draft',
}

export const isValidMessageCategory = (value: string): value is MessageCategories => {
    return Object.values(MessageCategories).includes(value as MessageCategories)
}
